import { get, post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import EvaluationItemUpdateRequest from "../form/request/EvaluationItemUpdateRequest";

const API_PREFIX = "/evaluationItem";

export const init = async () => {
  const response = await get(`${API_PREFIX}/`, authHeader());
  console.log("response", response);
  return response.data;
};

export const changeList = async param => {
  const response = await get(`${API_PREFIX}/${param}`, authHeader());
  console.log("response", response);
  return response.data;
};

export const update = async params => {
  const response = await post(`${API_PREFIX}/update`, new EvaluationItemUpdateRequest(params), authHeader());
  console.log("response", response);
  return response.data;
};
